import {
  FieldValues,
  Path,
  RegisterOptions,
  UseFormRegister,
} from "react-hook-form";
import { useEffect } from "react";

interface TextAreaProps<TFieldValues extends FieldValues> {
  fieldKey: Path<TFieldValues>;
  placeholder: string;
  defaultValue?: string;
  className?: string;
  register: UseFormRegister<TFieldValues>;
  registerOptions?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
}

export const TextArea = <TFieldValues extends FieldValues>({
  fieldKey,
  placeholder,
  className,
  defaultValue,
  register,
  registerOptions,
}: TextAreaProps<TFieldValues>) => {
  useEffect(() => {
    const textArea = document.getElementById("textarea");
    if (textArea) {
      textArea.style.height = "auto";
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  }, []);
  return (
    <textarea
      id="textarea"
      autoCorrect="on"
      autoCapitalize="sentences"
      spellCheck="true"
      style={{ height: "auto" }}
      defaultValue={defaultValue}
      className={`resize-none no-scrollbar w-full ${className}`}
      onInput={(e) => {
        const scrollY = window.scrollY;
        const target = e.currentTarget;
        target.style.height = "auto";
        target.style.height = `${target.scrollHeight}px`;
        window.scrollTo({ top: scrollY });
      }}
      placeholder={placeholder}
      {...register(fieldKey, registerOptions)}
    />
  );
};
export default TextArea;
